<template>
  <el-table-column align="center" label="申诉单信息">
    <el-table-column label="申诉单号" width="100" prop="complaintAppeal.id"></el-table-column>
    <el-table-column label="工单名称&类型" width="310" v-slot="{ row }">
      <task-info-mod :data="row.complaintAppeal"></task-info-mod>
    </el-table-column>
    <el-table-column label="提单人" width="100" prop="complaintAppeal.name"></el-table-column>
  </el-table-column>
</template>

<script>
import TaskInfoMod from './TaskInfoMod.vue'

export default {
  name: 'ComplaintTaskInfoCol',
  components: {
    TaskInfoMod
  },
  props: {
    data: Object
  }
}
</script>
